import React from 'react';
import './Cards.scss'
import { Container, Row, Col } from 'react-bootstrap';
import {
    ImgDocumentManagement,
    ImgAssessment,
    ImgFacilitySpatialManagement,
    ImgMapSystem,
    ImgBridgeAnalysis,
    ImgSystemManagement
} from '../../../style/images/system-icons'
import { getCookie } from 'Uitilities/cookie';

const CardOtherFunctions = ({func}) => {
    const role = getCookie("role");
    const display = () => {
        let temp = []
        if (func.length>0){
            func.forEach(item=>{
                if (item.name.includes("文件管理")){
                    temp.push(
                        <Col className='col-2 p-3' key={item.key}>
                        <div className="text-center">
                            <img src={ImgDocumentManagement} width="50" alt="" />
                            <div><a target="_self" href="./Other/FileSearch">文件管理</a></div>
                        </div>
                    </Col>
                )
                // }else if (item.name.includes("考評作業管理")){
                //     temp.push(
                //         <Col className='col-2 p-3' key={item.key}>
                //         <div className="text-center">
                //             <img src={ImgAssessment} width="50" alt="" />
                //             <div><a target="_self" href="./維修及施工管理-01.html">考評作業管理</a></div>
                //         </div>
                //     </Col>
                //     )
                }else if (item.name.includes("設施空間管理")){
                    temp.push(
                        <Col className='col-2 p-3' key={item.key}>
                        <div className="text-center">
                            <img src={ImgFacilitySpatialManagement} width="50" alt="" />
                            <div><a target="_self" href="./Other/FacilitiesManagement">橋下空間管理</a></div>
                        </div>
                    </Col>
                    ) } else if (item.name.includes("橋梁燈具管理")) {
                        temp.push(
                            <Col className='col-2 p-3' key={item.key}>
                                <div className="text-center">
                                    <img src={ImgSystemManagement} width="50" alt="" />
                                    <div><a target="_self" href="./Other/LightManage">橋梁燈具管理</a></div>
                                </div>
                            </Col>
                        )
                    }
                
            })
        }
        return temp;
    }
    const displaySec = () => {
        let temp = []
        if (func.length>0){
            func.forEach(item=>{
                if (item.name.includes("圖資系統")){
                    temp.push(
                        <Col className='col-2 p-3' key={item.key}>
                        <div className="text-center">
                            <img src={ImgMapSystem} width="50" alt="" />
                            <div><a target="_self" href="./Other/MapSystem">圖資系統</a></div>
                        </div>
                    </Col>
                )
                }else if (item.name.includes("橋梁分析")){
                    temp.push(
                        <Col className='col-2 p-3' key={item.key}>
                        <div className="text-center">
                            <img src={ImgBridgeAnalysis} width="50" alt="" />
                            <div><a target="_self" href="./Other/Analysis">橋梁分析</a></div>
                        </div>
                    </Col>
                    )
                }else if (item.name.includes("系統管理模組")){
                    temp.push(
                        <Col className='col-2 p-3' key={item.key}>
                        <div className="text-center">
                            <img src={ImgSystemManagement} width="50" alt="" />
                            <div><a target="_self" href="./Other/SystemManage">系統管理模組</a></div>
                        </div>
                    </Col>
                    )
                }
            })
        }
        return temp;
    }
    return (
        <Container>
            <Row>
                <h4 className="l-system-switch-panel__title text-left mb-3">其他功能群組</h4>
            </Row>
            <Row>
                {display()}
                {displaySec()}
            </Row>
        </Container>
    )
}

export default CardOtherFunctions;